"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxInProduct = exports.UpdateTaxGroup = exports.CreateTaxGroup = exports.TaxIDs = void 0;
const mobx_1 = require("mobx");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("@getgreenline/shared");
var TaxIDs;
(function (TaxIDs) {
    TaxIDs[TaxIDs["GST"] = 1] = "GST";
    TaxIDs[TaxIDs["PST (BC)"] = 2] = "PST (BC)";
    TaxIDs[TaxIDs["HST (Ontario)"] = 3] = "HST (Ontario)";
    TaxIDs[TaxIDs["GST (Alberta)"] = 4] = "GST (Alberta)";
    TaxIDs[TaxIDs["PST (Saskatchewan)"] = 5] = "PST (Saskatchewan)";
    TaxIDs[TaxIDs["RST (Manitoba)"] = 6] = "RST (Manitoba)";
    TaxIDs[TaxIDs["PST (Quebec)"] = 7] = "PST (Quebec)";
    TaxIDs[TaxIDs["HST"] = 8] = "HST";
    TaxIDs[TaxIDs["State tax (California)"] = 9] = "State tax (California)";
    TaxIDs[TaxIDs["Uniform local tax (California)"] = 10] = "Uniform local tax (California)";
    TaxIDs[TaxIDs["State tax (Colorado)"] = 11] = "State tax (Colorado)";
    TaxIDs[TaxIDs["IPO"] = 12] = "IPO";
    TaxIDs[TaxIDs["IVA CF"] = 13] = "IVA CF";
    TaxIDs[TaxIDs["IVA"] = 14] = "IVA";
    TaxIDs[TaxIDs["Online store tax"] = 15] = "Online store tax";
    TaxIDs[TaxIDs["First nation cannabis tax"] = 16] = "First nation cannabis tax";
    TaxIDs[TaxIDs["Vape PST (BC)"] = 17] = "Vape PST (BC)";
    TaxIDs[TaxIDs["VPT (Saskatchewan)"] = 18] = "VPT (Saskatchewan)";
    TaxIDs[TaxIDs["LCT (Saskatchewan)"] = 19] = "LCT (Saskatchewan)";
})(TaxIDs || (exports.TaxIDs = TaxIDs = {}));
class CreateTaxGroup {
    constructor() {
        this.taxLines = [];
    }
    get totalPercent() {
        let total = 0;
        this.taxLines.forEach((taxLine) => (total += taxLine.percent || 0));
        return total;
    }
}
exports.CreateTaxGroup = CreateTaxGroup;
__decorate([
    mobx_1.observable
], CreateTaxGroup.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], CreateTaxGroup.prototype, "taxLines", void 0);
__decorate([
    mobx_1.computed
], CreateTaxGroup.prototype, "totalPercent", null);
class UpdateTaxGroup extends CreateTaxGroup {
}
exports.UpdateTaxGroup = UpdateTaxGroup;
__decorate([
    mobx_1.observable
], UpdateTaxGroup.prototype, "id", void 0);
class TaxInProduct {
}
exports.TaxInProduct = TaxInProduct;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], TaxInProduct.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], TaxInProduct.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], TaxInProduct.prototype, "percent", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], TaxInProduct.prototype, "exemptOverride", void 0);
//# sourceMappingURL=taxes.js.map